import { render, staticRenderFns } from "./new_password_request_form.vue?vue&type=template&id=d040c254&scoped=true"
import script from "./new_password_request_form.vue?vue&type=script&lang=ts"
export * from "./new_password_request_form.vue?vue&type=script&lang=ts"
import style0 from "./new_password_request_form.vue?vue&type=style&index=0&id=d040c254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d040c254",
  null
  
)

export default component.exports